// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import AdvancedAnalyticsView from "../../components/advancedAnalytics";

const AdvancedAnalytics = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <AdvancedAnalyticsView />
    </Main>
  </>
);

export default AdvancedAnalytics;
